import IPersonalDetails from '@/models/interfaces/IPersonalDetails';
import PersonalDetails from '@/models/PersonalDetails';
import EmailValidationResult from '../../models/EmailValidationResult'; // Update this with the correct path
import IPersonalDetailsState from './interfaces/personal-details-state.d';

export default class PersonalDetailsState implements IPersonalDetailsState {
    public personalDetails: IPersonalDetails = new PersonalDetails();

    public isValidVerificationCode: boolean = true;

    public isPrePhoneEntry: boolean = false;

    public emailCapture: EmailValidationResult = new EmailValidationResult();
}
